<div class="LearnModulesOverlay">
  <div class="LearnModulesBox">
    <div class="Learns_Iocns">
      <img src="assets/images/flag-icons.png" alt="">
    </div>
    <p class="textPara montserrat-regular navColor mg-b30">You have reached the end of {{config.currModuleName}}</p>
    <h6 class="upnext mg-b10">Up Next</h6>
    <h3 class="heading24 montserrat-medium darkColor mg-b40">{{config.nextModuleName}}</h3>
    <button (click)="moveToNextModule()" type="button" class="btn btn-primary long-btn30"><span>Start next
        Module</span></button>
  </div>
</div>